class LOPRichTextAnimations {
  constructor() {
    this.init();
  }

  init() {
    // Esperar a que el DOM esté completamente cargado
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupAnimations());
    } else {
      this.setupAnimations();
    }
  }

  setupAnimations() {
    // Verificar si IntersectionObserver está disponible
    if (!('IntersectionObserver' in window)) {
      // Fallback para navegadores que no soportan IntersectionObserver
      this.showAllElements();
      return;
    }

    // Configurar el observer
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -100px 0px', // Activar cuando el elemento esté 100px dentro del viewport
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateElement(entry.target);
        }
      });
    }, observerOptions);

    // Buscar todas las secciones rich-text con animaciones habilitadas
    const richTextSections = document.querySelectorAll('.LOP-rich-text--fade-enabled');
    
    richTextSections.forEach(section => {
      const fadeElements = section.querySelectorAll('.LOP-fade-element');
      
      fadeElements.forEach(element => {
        this.observer.observe(element);
      });
    });
  }

  animateElement(element) {
    // Añadir un pequeño retraso para crear efecto escalonado
    const delay = element.classList.contains('rich-text__image') ? 0 : 200;
    
    setTimeout(() => {
      element.classList.add('LOP-fade-in-view');
    }, delay);

    // Dejar de observar el elemento una vez que se ha animado
    this.observer.unobserve(element);
  }

  showAllElements() {
    // Fallback: mostrar todos los elementos sin animación
    const fadeElements = document.querySelectorAll('.LOP-fade-element');
    fadeElements.forEach(element => {
      element.style.opacity = '1';
      element.style.transform = 'translateX(0)';
    });
  }

  // Método para reiniciar animaciones (útil para theme editor)
  resetAnimations() {
    const fadeElements = document.querySelectorAll('.LOP-fade-element');
    fadeElements.forEach(element => {
      element.classList.remove('LOP-fade-in-view');
    });
    
    // Reiniciar observadores
    if (this.observer) {
      this.observer.disconnect();
      this.setupAnimations();
    }
  }
}

// Inicializar las animaciones
const lopRichTextAnimations = new LOPRichTextAnimations();

// Reiniciar animaciones cuando se cambian configuraciones en el theme editor
document.addEventListener('shopify:section:load', () => {
  lopRichTextAnimations.resetAnimations();
});

document.addEventListener('shopify:section:reorder', () => {
  lopRichTextAnimations.resetAnimations();
});
